import { render } from "./debian.svg?vue&type=template&id=e04e9804?inline"
const script = {}

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__